import { AlkLogger } from '@alk/core';
import { DeepRequired } from '../../../types';
import { ICcypair } from '@alk/currency';
import { IResolvedTenor, ITenorRequest } from '../../../interfaces';
import { ISO8601, Tenor } from '@alk/dates';
import {
    ITenor,
    ITenorResolveRequest,
    TenorResolveRequest,
    TenorResolveResponse,
} from 'sfx-web-contract';

export function fromBackendTenorToResolvedTenor(tenor: ITenor): IResolvedTenor {
    return {
        tenor: tenor.Tenor as Tenor,
        date: tenor.Date as ISO8601,
        instrument: tenor.Instrument as ICcypair,
    };
}

export function tenorResolveDecode(data: Uint8Array): Array<IResolvedTenor> {
    try {
        const response = TenorResolveResponse.decode(data);

        return response.Tenors.map(fromBackendTenorToResolvedTenor);
    } catch (error) {
        AlkLogger.error(`[TenorResolveAdapterService#decode] Decoding error ${ data } not decode to TenorResolveResponse message`);
        throw error;
    }
}

export function tenorResolveEncode(tenors: Array<ITenorRequest>): Uint8Array {

    const fullRequest: DeepRequired<ITenorResolveRequest> = {
        Tenors: tenors.map(tenor => ({
            Instrument: tenor.instrument,
            Tenor: tenor.tenor,
            Date: null,
        })),
    };

    const request = TenorResolveRequest.create(fullRequest);

    return TenorResolveRequest.encode(request).finish();
}
